import { render } from "./Paperclip.vue?vue&type=template&id=078bed0c"
import script from "./Paperclip.vue?vue&type=script&lang=js"
export * from "./Paperclip.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__